import ZenDeskChat from "Views/SpenmoSupport/ZenDeskChat";
import ContactForm from "Views/SpenmoSupport/ContactForm";

import { SUPPORT_STATUS } from "./SupportStatus";

export const SUPPORT_COMPONENT = {
  [SUPPORT_STATUS.ONLINE]: ZenDeskChat,
  [SUPPORT_STATUS.OFFLINE]: ContactForm,
};
